export const individualRegisterFormFields = [
  {
    name: "name",
    label: "Parent Name",
    type: "text",
    required: true,
    placeholder: "eg. : Sam Deo",
    colSpan: 2,
  },
  {
    name: "email",
    label: "Parent Email Id",
    type: "email",
    required: true,
    placeholder: "eg. : example123@mail.con",
    colSpan: 2,
  },
  {
    name: "phone",
    label: "Parent Phone Number",
    type: "tel",
    required: true,
    placeholder: "eg. : 9876543210",
    colSpan: 2,
  },
  // {
  //   name: "class",
  //   label: "Class",
  //   type: "select",
  //   required: true,
  //   placeholder: "Select Class",
  //   selectOptions: [
  //     { id: 1, label: "Class 1st", value: 1 },
  //     { id: 2, label: "Class 2nd", value: 2 },
  //     { id: 3, label: "Class 3rd", value: 3 },
  //     { id: 4, label: "Class 4th", value: 4 },
  //     { id: 5, label: "Class 5th", value: 5 },
  //     { id: 6, label: "Class 6th", value: 6 },
  //     { id: 7, label: "Class 7th", value: 7 },
  //     { id: 8, label: "Class 8th", value: 8 },
  //   ],
  //   colSpan: 2,
  // },
  {
    name: "password",
    label: "Password",
    type: "password",
    required: true,
    placeholder: "Password",
    colSpan: 2,
  },
];
